import React from 'react';
import PropTypes from 'prop-types';
import GoogleBadge from '../../assets/images/google-play-badge.svg';
import AppleBadge from '../../assets/images/App_Store_Badge_US-UK_RGB_blk.svg';

const AppStoreBadges = ({ brand, text, ...otherProps }) => {
    let url,
        badge = '';

    if (brand === 'Google') {
        url =
            'https://play.google.com/store/apps/details?id=com.safecoinsurance.consumer&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
        badge = GoogleBadge;
    }

    if (brand === 'Apple') {
        url = 'https://itunes.apple.com/us/app/safeco-mobile/id1191491672';
        badge = AppleBadge;
    }
    return (
        <a {...otherProps} href={url} target="_blank">
            <img className="storeBadge" alt={text ? text : url} src={badge} />
        </a>
    );
};

AppStoreBadges.propTypes = {
    brand: PropTypes.string.isRequired,
    text: PropTypes.string
};

export default AppStoreBadges;



// WEBPACK FOOTER //
// ./src/components/AppStoreBadges/AppStoreBadges.jsx